import { NAV_DATA } from 'constants/navConstants';
import featureFlags from '../../../../util/featureFlags';

// TODO: add parent for tracking/active el?

const { SECONDARY: { PAPER, GUEST_LIST, WEDDINGS, WEBSITE } } = NAV_DATA;

class SecondaryNavDataV2 {
  constructor(userContext = {}) {
    this.userContext = userContext;
  }

  // Invites - Pre/post auth
  getInvitesItems() {
    const saveTheDate = {
      path: '/wedding-planning/save-the-date/shop',
      title: 'Save The Dates',
      id: PAPER.SAVE_THE_DATE,
    };
    const changeTheDate = {
      path: '/wedding-planning/change-the-date/shop',
      title: 'Change The Dates',
      newTag: true,
      id: PAPER.CHANGE_THE_DATE,
    };
    const invitations = {
      path: '/wedding-planning/invitations/shop',
      title: 'Invitations',
      id: PAPER.INVITATION,
    };
    const enclosureCards = {
      path: '/wedding-planning/enclosures/shop',
      title: 'Enclosure Cards',
      id: PAPER.DETAILS,
    };
    const menus = {
      path: '/wedding-planning/menus/shop',
      title: 'Menus',
      id: PAPER.MENU,
    };
    const programs = {
      path: '/wedding-planning/programs/shop',
      title: 'Programs',
      id: PAPER.PROGRAM,
    };
    const thankYouCards = {
      path: '/wedding-planning/thank-you-cards/shop',
      title: 'Thank You Cards',
      id: PAPER.THANK_YOU,
    };
    const holidayCards = {
      path: '/wedding-planning/holiday-cards/shop',
      title: 'Holiday Cards',
      id: PAPER.HOLIDAY,
    };

    const items = [
      saveTheDate,
      changeTheDate,
      invitations,
      enclosureCards,
      menus,
      programs,
      thankYouCards,
      holidayCards
    ];

    if (this.userContext.has_invitation_account) {
      items.unshift({
        title: 'Your Orders + Drafts',
        path: '/wedding-planning/projects',
        id: PAPER.PROJECTS,
      });
    }

    return items;
  }

  // Wedding/Planning - Pre/post auth
  getWeddingItems() {
    const currentPath = window.location.pathname;
    let items = this.userContext.has_wedding_account ? this.weddingAccountItems() : this.nonWeddingAccountItems();

    // Only show the inspiration admin dropdown when viewing inspiration
    if (this.userContext.is_inspiration_admin && currentPath.indexOf('/inspiration') > -1) {
      items.push({
        id: 'vendor-admin',
        title: 'Admin',
        path: '',
        children: this.adminDropdownItems(),
        className: 'hidden-xs'
      });
    }

    items = this.setActiveItem(items, currentPath);

    return items;
  }

  // Guest List - Post auth
  // could be static
  getGuestListItems() {
    const guestDirectory = {
      path: '/wedding/manage/guests/all',
      title: 'All Guests',
      id: GUEST_LIST.ALL_GUESTS,
    };
    const buildGuestLists = {
      path: '/wedding/manage/guests/build',
      title: 'Build Guest Lists',
      id: GUEST_LIST.BUILD,
    };
    const addressEnvelopes = {
      path: '/wedding/manage/guests/envelopes',
      title: 'Address Envelopes',
      id: GUEST_LIST.ENVELOPES,
    };
    const trackRSVP = {
      path: '/wedding/manage/guests/rsvps/overview',
      title: 'Track RSVPs',
      id: GUEST_LIST.TRACK_RSVPS,
    };
    const requestRsvpAccess = {
      path: '/wedding/manage/guests/rsvp-notifications',
      // receivesNotifications: true,
      title: 'View RSVP Requests',
      id: GUEST_LIST.RSVP_REQUESTS,
    };

    return [guestDirectory, buildGuestLists, addressEnvelopes, trackRSVP, requestRsvpAccess];
  }

  // Website - Post auth
  // Could be static
  getWebsiteItems() {
    const manageWebsite = {
      id: WEBSITE.MANAGE,
      path: '/wedding/manage/website/manage',
      title: 'Manage Website',
    };

    const editWebsite = {
      id: WEBSITE.EDIT,
      path: '/wedding/manage/website/pages/home',
      title: 'Edit Pages',
    };

    const viewDesigns = {
      id: WEBSITE.DESIGNS,
      path: '/wedding/manage/website/designs',
      title: 'View Designs',
    };

    return [manageWebsite, editWebsite, viewDesigns];
  }

  setActiveItem(items, currentPath) {
    return items.map((item) => {
      const currentItem = item;

      if (currentItem.title === 'Wedding Vendors') {
        // Make this item active for any vendor- or venue-related path, including wedding-venues,
        // wedding-photographers, wedding-florists, etc.
        currentItem.isActive = currentPath.indexOf('/inspire') > -1;
      } else if (currentItem.text === 'Admin') {
        currentItem.isActive = false;
      } else {
        currentItem.isActive = (currentPath.indexOf(currentItem.path) > -1);
      }

      return currentItem;
    });
  }

  weddingAccountItems() {
    return [
      {
        id: WEDDINGS.GUEST_LIST,
        activeRegex: /^\/wedding\/manage\/guests/,
        title: 'Guest List',
        path: '/wedding/manage/guests',
        children: this.guestListDropdownItems(),
        className: 'hidden-sm hidden-xs',
        showCaret: true,
      },
      {
        id: WEDDINGS.EVENTS,
        activeRegex: /^\/wedding\/manage\/events/,
        title: 'Events',
        path: '/wedding/manage/events',
        className: 'hidden-sm hidden-xs'
      },
      {
        id: WEDDINGS.CHECKLIST,
        activeRegex: /^\/wedding\/manage\/wedding-checklist/,
        title: 'Wedding Checklist',
        path: '/wedding/manage/wedding-checklist',
        className: 'hidden-sm hidden-xs'
      },
      {
        id: WEDDINGS.REAL_WEDDINGS,
        activeRegex: /^\/inspiration\/weddings/,
        title: 'Real Weddings',
        path: '/inspiration/weddings',
        children: this.realWeddingsDropdownItems()
      },
      {
        id: WEDDINGS.VENDORS,
        activeRegex: /^\/inspire\/search/,
        title: 'Wedding Vendors',
        path: '/inspire/search',
        children: this.inspireVendorsDropdownItems()
      },
      {
        id: WEDDINGS.EXPERT_ADVICE,
        activeRegex: /^\/expert-advice/,
        title: 'Expert Advice',
        path: '/expert-advice'
      }
    ];
  }

  nonWeddingAccountItems() {
    const { userContext } = this;
    const updatededWeddingsFlows = featureFlags.get('updateWeddingsFlows');
    const createWeddingAccount = !userContext.has_wedding_account && userContext.has_completed_onboarding;
    const weddingsCreateQuery = updatededWeddingsFlows && createWeddingAccount ? '?weddingscreate=true' : '';
    return [
      {
        id: 'wedding-checklist',
        activeRegex: /^\/wedding-planning\/checklist/,
        title: 'Wedding Checklist',
        path: createWeddingAccount ? `/wedding/manage/wedding-checklist${weddingsCreateQuery}` : '/wedding-planning/checklist',
      },
      {
        id: 'guest-list',
        activeRegex: /^\/wedding-planning\/guests/,
        title: 'Guest List',
        path: createWeddingAccount ? `/wedding/manage/guests/all${weddingsCreateQuery}` : '/wedding-planning/guests',
      },
      {
        id: 'real-weddings',
        activeRegex: /^\/inspiration\/weddings/,
        title: 'Real Weddings',
        path: '/inspiration/weddings',
        children: this.realWeddingsDropdownItems()
      },
      {
        id: 'inspire-wedding-vendors',
        activeRegex: /^\/inspire\/search/,
        title: 'Wedding Vendors',
        path: '/inspire/search',
        children: this.inspireVendorsDropdownItems()
      },
      {
        id: 'expert-advice',
        activeRegex: /^\/expert-advice/,
        title: 'Expert Advice',
        path: '/expert-advice'
      }
    ];
  }

  guestListDropdownItems() {
    const items = [
      { title: 'All Guests', path: '/wedding/manage/guests/all' },
      { title: 'Build Guest List', path: '/wedding/manage/guests/build' },
      { title: 'Address Envelopes', path: '/wedding/manage/guests/envelopes' },
      { title: 'Track RSVPs', path: '/wedding/manage/guests/rsvps/overview' }
    ];

    // TODO: Add 'has_guest_requests' to the user context
    if (this.userContext.has_guest_requests) {
      items.push({
        title: 'View RSVP Requests',
        path: '/wedding/manage/guests/rsvp-notifications',
        id: 'rsvp-notifications',
      });
    }

    return items;
  }

  realWeddingsDropdownItems() {
    return [
      { title: 'Austin, TX', path: '/inspiration/weddings?location=Austin%2C+TX' },
      { title: 'Charlottesville, VA', path: '/inspiration/weddings?location=Charlottesville%2C+VA' },
      { title: 'Charleston, SC', path: '/inspiration/weddings?location=Charleston%2C+SC' },
      { title: 'Chicago, IL', path: '/inspiration/weddings?location=Chicago%2C+IL' },
      { title: 'Denver, CO', path: '/inspiration/weddings?location=Denver%2C+CO' },
      { title: 'Miami, FL', path: '/inspiration/weddings?location=Miami%2C+FL' },
      { title: 'Napa, CA', path: '/inspiration/weddings?location=Napa%2C+CA' },
      { title: 'Nashville, TN', path: '/inspiration/weddings?location=Nashville%2C+TN' },
      { title: 'New Orleans, LA', path: '/inspiration/weddings?location=New+Orleans%2C+LA' },
      { title: 'New York, NY', path: '/inspiration/weddings?location=New+York%2C+NY' },
      { title: 'Richmond, VA', path: '/inspiration/weddings?location=Richmond%2C+VA' },
      { title: 'San Francisco, CA', path: '/inspiration/weddings?location=San+Francisco%2C+CA' },
      { title: 'Seattle, WA', path: '/inspiration/weddings?location=Seattle%2C+WA' },
      { title: 'Tampa, FL', path: '/inspiration/weddings?location=Tampa%2C+FL' },
      { title: 'View All Weddings', path: '/inspiration/weddings' }
    ];
  }

  inspireVendorsDropdownItems() {
    return [
      { title: 'Wedding Venues', path: '/inspire/search/wedding-venues' },
      { title: 'Photographers', path: '/inspire/search/wedding-photographers' },
      { title: 'Videographers', path: '/inspire/search/wedding-videographers' },
      { title: 'Caterers', path: '/inspire/search/wedding-caterers' },
      { title: 'Florists', path: '/inspire/search/wedding-florists' }
    ];
  }

  adminDropdownItems() {
    return [
      { title: 'Manage Weddings', path: '/inspiration/curation/weddings' },
      { title: 'Manage Listings', path: '/inspiration/curation/vendors' },
      { title: 'New Listing', path: '/inspiration/manage/listings/new' },
    ];
  }
}

export default SecondaryNavDataV2;



// WEBPACK FOOTER //
// ./src/components/common/header/SecondaryNavV2/SecondaryNavDataV2.js